import { UserRequiresPaymentVerificationResultAjax } from './user-requires-payment-verification.backend-model';
import { UserRequiresPaymentVerification } from './user-requires-payment-verification.model';

export function transformUserRequiresPaymentVerification(
  userRequiresPaymentVerificationResultAjax: UserRequiresPaymentVerificationResultAjax,
  authUid: string,
): UserRequiresPaymentVerification {
  return {
    id: authUid,
    userRequiresPaymentVerification:
      userRequiresPaymentVerificationResultAjax.userRequiresPaymentVerification,
  };
}
